import axios from "axios";


console.log('hostAutoPlay', `http://${process.env.VUE_APP_HOST_API_BACKEND}`)
export class AutoPlayService{
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND}`;
    static getALLAutoPlays() {
        let dataURL = `${this.serverURL}/autoplayers`;
        // console.log('dataURL.usuario');
        //  console.log(dataURL);
            return axios.get(dataURL);
    }
    
    static getAutoPlay(AutoPlayId){
        let dataURL = `${this.serverURL}/autoplayer/${AutoPlayId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static getAutoPlayVslId(vslId){
        let dataURL = `${this.serverURL}/autoplayerVSL/${vslId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static createAutoPlay(AutoPlay){
        let dataURL = `${this.serverURL}/autoplayer/`;
        console.log('dataURL.AutoPlay');
        console.log(dataURL,AutoPlay);
        return axios.post(dataURL,AutoPlay);
    }
       

    static updateAutoPlay(AutoPlay, vslId){
        let dataURL = `${this.serverURL}/autoplayer/${vslId}`;
        return axios.put(dataURL, AutoPlay)
    }

    static deleteAutoPlay(AutoPlayId){
        let dataURL = `${this.serverURL}/autoplayer/${AutoPlayId}`;
        return axios.delete(dataURL);
    }

    
       


}